import React, { useEffect } from 'react';
import isEmpty from 'lodash/isEmpty';
import dayjs from 'core/utils/dayjs';
import Cookies from 'js-cookie';
import { useSelector, useDispatch } from 'react-redux';
import { useGetBonusOffers } from 'core/modules/BonusOffers/hooks';
import { useGetButtonUrl } from 'core/modules/BonusButton/hooks/useGetButtonUrl';
import { selectCookieDomain, selectIsHttps } from 'core/selectors/env';
import { BONUS_BUTTON_MODAL_WAS_SHOWN } from 'core/modules/BonusButton/utils/keys';
import { parseBonusButton } from 'core/modules/BonusButton/utils/parseBonusButton';
import config from 'core/modules/BonusButton/configs';
import Modal from 'core/modules/Modal/Modal';
import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';
import {
  triggerBonusButtonModalIsViewedGaEvent, triggerBonusButtonModalIsClosedGaEvent,
} from 'core/modules/BonusButton/actions';

import './BonusButtonModal.scss';

function BonusButtonModal() {
  const dispatch = useDispatch();
  const cookieDomain = useSelector(selectCookieDomain);
  const isHttps = useSelector(selectIsHttps);
  const {
    getTitle, getDescription, dateFormat, getTermsText,
  } = config.modalConfig;
  const buttonUrl = useGetButtonUrl();

  const { bonusButtonModal } = useGetBonusOffers();
  const {
    endDate, maxRewardAvailable, minSpendToQualify, brandCurrency,
  } = parseBonusButton(bonusButtonModal);

  useEffect(() => {
    Cookies.set(BONUS_BUTTON_MODAL_WAS_SHOWN, 'true', { path: '/', domain: cookieDomain, secure: isHttps });
  }, []);

  useEffect(() => {
    dispatch(triggerBonusButtonModalIsViewedGaEvent());
  }, []);

  const onCloseCallback = () => dispatch(triggerBonusButtonModalIsClosedGaEvent());

  if (isEmpty(bonusButtonModal)) {
    return null;
  }

  const endDateFormated = dayjs(endDate).format(dateFormat);

  const title = getTitle(maxRewardAvailable, brandCurrency);
  const termsText = getTermsText();
  const description = getDescription(brandCurrency, minSpendToQualify, endDateFormated, maxRewardAvailable);

  return (
    <Modal className="mn_bonusButtonModal" onCloseCallback={onCloseCallback}>
      <div className="mn_icon" />
      <h2 id="mn_dialogTitle">{title}</h2>
      <p id="mn_dialogDescription">{description}</p>
      <div className="mn_ctaAndTerms">
        <a className="mn_button mn_getButton" href={buttonUrl}>Get the button</a>
        {termsText && <div className="mn_terms">{termsText}</div>}
      </div>
    </Modal>
  );
}

export default (props) => <ComponentErrorBoundary><BonusButtonModal {...props} /></ComponentErrorBoundary>;
